import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.admin');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.admin/view.scss */
/* src/app/component.nav.admin/view.scss: no such file or directory */`],
})
export class ComponentNavAdminComponent implements OnInit, OnDestroy {

    private routerSub: Subscription;

    public toggleMenu = false;
    public userinfo: any = null;
    public session: any = null;

    public menus = [
        { title: '대시보드', icon: 'fas fa-home', url: '/home' },

        { title: '원스톱등록', icon: 'fas fa-check-circle', url: '/admin/user/initialize' },

        { title: '회원관리', icon: 'fas fa-users', url: '/admin/user/list' },

        {
            title: '농장관리',
            icon: 'fas fa-store',
            baseUrl: '/admin/farm',
            url: '/admin/farm/list'
        },

        { title: 'A/S관리', icon: 'fas fa-newspaper', url: '/admin/as/list' },

        {
            title: '고객센터',
            icon: 'fas fa-circle-info',
            baseUrl: '/community',
            child: [
                {
                    title: '공지사항',
                    url: '/community/notice',
                    move: '/community/notice/list'
                },
                {
                    title: '문의사항',
                    url: '/community/faq',
                    move: '/community/faq/list'
                }
            ]
        },

        {
            title: '데이터통계',
            icon: 'fas fa-chart-line',
            baseUrl: '/admin/monitoring',
            child: [
                { title: '날짜별선별통계', url: '/admin/monitoring/statistic' },
                { title: '스마트축산정보연계', url: '/admin/monitoring/api' },
                { title: 'K-FARM 데모축사', url: '/admin/monitoring/kfarm' },
                { title: '선별기로그', url: '/admin/monitoring/machine' },
                { title: '계란시세정보', url: '/admin/monitoring/eggprice' }
            ]
        }
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         public router: Router    ) { }

    async ngOnInit() {

        await this.service.init();

        const { code, data } = await wiz.call('load');
        this.userinfo = code === 200 ? data : null;

        await this.service.auth.allow("admin", "home");
        this.session = this.service.auth.session;

        this.routerSub = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(async () => {
                this.closeNavOnMobile();
                await this.service.render();
            });

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    isMenuActive(menu) {

        const current = this.router.url.split('?')[0];

        if (menu.baseUrl) {
            return current === menu.baseUrl ||
                current.startsWith(menu.baseUrl + '/');
        }

        if (menu.url) {
            return current === menu.url ||
                current.startsWith(menu.url + '/');
        }

        return false;
    }

    isChildActive(child) {

        const current = this.router.url.split('?')[0];

        return current === child.url ||
            current.startsWith(child.url + '/');
    }

    openMenuAndMove(menu) {
        if (!menu.child || menu.child.length === 0) return;

        const first = menu.child[0];
        this.router.navigateByUrl(first.move || first.url);

        this.closeNavOnMobile();
    }


    closeAllMenus() {
        this.closeNavOnMobile();
    }

    isMobile() {
        return window.innerWidth < 1024;
    }

    closeNavOnMobile() {
        if (this.isMobile()) {
            this.toggleMenu = false;
        }
    }

    async toggle() {
        this.toggleMenu = !this.toggleMenu;
        await this.service.render();
    }
}

export default ComponentNavAdminComponent;